<template>
  <div class="row mx-3 justify-content-start">
    <span class="form-label align-self-start size-12 p-0">求人の特徴</span>
    <div class="w-100 p-0 d-flex gap-0 flex-wrap">
      <div
        v-for="(jobFeature, idx) in props.jobFeatures.flatMap((category) =>
          category.children?.map((children) => ({ categoryName: category.name, children }))
        )"
        :key="jobFeature?.children.id"
        class="mb-2 d-flex align-items-center col-auto p-0 mw-100"
      >
        <Field
          :id="`candidate_resume_job_feature_${idx}`"
          :name="`candidate_resume_job_feature[${idx}]`"
        >
          <div class="align-items-center col-auto d-flex flex-nowrap w-100">
            <p
              class="col-auto bg-silver-primary px-3 py-1 mb-0 border border-fourth rounded-2 me-1 text-truncate flex-shrink-1"
            >
              {{ jobFeature?.children.name }}
            </p>
            <div class="col-md-2 col-auto">
              <div class="col-md-2 col-2">
                <span class="me-3">
                  <img
                    src="@/assets/image/icon-close-delete.svg"
                    role="button"
                    class="border rounded-circle border-third p-0d25"
                    @click="onRemoveJobFeature(jobFeature?.children.id)"
                  />
                </span>
              </div>
            </div>
          </div>
        </Field>
      </div>
      <div class="d-flex justify-content-center w-100 mt-2">
        <Button
          variant="primary"
          button-style="outlined"
          :custom-size="true"
          :rounded="false"
          class="mw-184x h-36x w-15 size-12 rounded-5 d-flex justify-content-center align-items-center"
          icon="plus"
          @click="addJobFeature"
        >
          求人の特徴を追加する
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate';
import Button from '@/components/shared/button/Button.vue';

const onRemoveJobFeature = (id: number): void => {
  emit('remove', id);
};

const addJobFeature = (): void => {
  emit('open');
};

const props = defineProps({
  jobFeatures: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['open', 'remove']);
</script>
